import React, { Component, Fragment, useEffect, useContext, useState } from "react";
import * as cookie from "react-cookies";
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';
import {Collapse} from "@material-ui/core";
import { CSSTransition } from 'react-transition-group';

import { RelativeSwitch, Button, RelativeRoute, LoadingSpinner } from './../common/common';
import { OnBoardingModal, PromptModal, AddPartyName, AddPartyDate } from "./../common/modal";
import { 
  sectionsToSubsections,
  objectFind,
  isEmpty,
  countMap,
  mapObjectToArray,
	extractCartData,
	relativePath,
	formatTime,
	formatPrice,
	arrayToObject
} from './../../lib/tools';
import { StoreView } from "../../components/views/storeView";
import { reduxWrapper } from './../../globalState';
import { ModalContext } from './../../contexts';
import { PartyInfoHeader } from './../structure';
import { ContestRegisterModal } from './../../contest/competition';
import { Link } from 'react-router-dom';

//Icons
import dropArrowIcon from "../../resources/icons/arrow-grey.png";
import plusGreenIcon from '../../resources/icons/plus-dark-green.svg';
import plusLightGreyIcon from '../../resources/icons/plus-light-grey.svg';
import listGreenIcon from '../../resources/icons/list-dark-green.svg';
import listLightGreyIcon from '../../resources/icons/list-light-grey.svg';
import cartLightGreyIcon from '../../resources/icons/cart-light-grey.svg';
import cartDarkGreenIcon from '../../resources/icons/cart-dark-green.svg';
import confettiIcon from '../../resources/icons/confetti.png';
import penGreenIcon from "../../resources/icons/pen-dark-green.svg";
import penGreyIcon from "../../resources/icons/pen-light-grey.svg";

//Images
import polaroidImg from '../../resources/images/compPolar.png';
import { getImage } from "../../lib/api";

// Base component for /minfest, takes care of routing
// const MyPartyRender = ({sections}) => {
// 	const [isShop, setIsShop] = useState(false);

// 	return(
// 		<Fragment>
// 			<PartyInfoHeader/>
// 	    <RelativeSwitch>
// 				<Route path=":section" render={({match: {params: {section}}}) => {
// 					const subSections = sectionsToSubsections(sections);
// 					const chosenSection = objectFind(subSections, x => x.vanity.toLowerCase() === section.toLowerCase());
					
// 					if(!chosenSection) return <Fragment><div className="myPartyBgWrapper"/><SectionWrapper/></Fragment>
// 					return <StoreView section={chosenSection}/>
// 				}}/>
// 				<Route render={() => {
// 					return(
// 						<Fragment>
// 							<div className="myPartyBgWrapper"/>
// 							<SectionWrapper/>
// 						</Fragment>
// 					)
// 				}}/>
// 			</RelativeSwitch>
// 		</Fragment>
// 	)
// };


const MyPartyRender = ({sections, history}) => {
	const [isShop, setIsShop] = useState(false);

	useEffect(() => {
		if (history.location.pathname === "/minfest") setIsShop(false)
	}, [history.location.pathname])

	return(
		<div className={["bob", isShop ? "minimize" : ""].join(" ")}>
			<PartyInfoHeader/>
			<div className="test">
				<CSSTransition
					classNames="myPartyBgWrapper"
					timeout={1000}
					in={!isShop}
					unmountOnExit
				>
					<div className="myPartyBgWrapper"/>
				</CSSTransition>
				<SectionWrapper/>
			</div>
			
			<RelativeRoute path=":section" render={({match: {params: {section}}}) => {
				const subSections = sectionsToSubsections(sections);
				const chosenSection = objectFind(subSections, x => x.vanity.toLowerCase() === section.toLowerCase());
				setIsShop(true);

				if(!chosenSection){
					return (
						<div className="test">
							<div className="myPartyBgWrapper"/>
							<SectionWrapper/>
						</div>
					) 
				} 

				return (
					<CSSTransition
					classNames="storeViewContainer"
					timeout={2000}
					in={isShop}
					unmountOnExit
					>
						<StoreView section={chosenSection}/>
					</CSSTransition>
				)
			}}/>

			{/* <RelativeRoute path=":section" render={() => {
				setIsShop(true);
				return(
					<CSSTransition
						classNames="test"
						timeout={500}
						in={isShop}
						unmountOnExit
					>
						<div className="test"/>
					</CSSTransition>
				)
			}}/> */}
		</div>
	)
};
const MyParty = reduxWrapper("loadSections")(MyPartyRender);
MyPartyRender.propTypes = {
	sections: PropTypes.object
}

//Takes care of actionbar navigation
const SectionWrapper = () => {
	const [showSectionNav, setShowSectionNav] = useState(false);
	return (
		<div className="myPartyWrapper">
			<div className="spacer"/>
			<div className={["partyWrapper", showSectionNav ? "showNav" : ""].join(" ")}>
				<SectionList/>
				<SectionNavigation/>
			</div>

			<ActionBar onClick={setShowSectionNav} isNav={showSectionNav}/>
		</div>
	)
};


class SectionListRender extends Component {
	static contextType = ModalContext;

	constructor(props) {
		super(props);
	}

	componentDidMount(){
		this.props.awaitUserInfo(data => {
			let isOnBoardingShown = cookie.load('SaveParty');
			if(!this.props.userId){
				this.props.awaitCart(data => {
					if (!isEmpty(data) && !isOnBoardingShown) {
						this.context.toggleModal(true, <OnBoardingModal/>)
					}
				});
			}
		})
	}

	prompt = {
		text: "Vil du annullere din reservation?",
		confirm: () => {
			this.props.setPartyInfo({
				data: {reserved: false}
			}).then(() => {
				this.context.toggleModal(false);
			})
		},
		decline: () => {
			this.context.toggleModal(false);
		},
		confirmText: "Ja",
		declineText: "Nej"
	};
	
	cancelReservation = () => {
		this.context.toggleModal(true,
			<PromptModal {...this.prompt}/>
		)
	}

	registerParty = () => {
		var data = JSON.parse(sessionStorage.getItem("contest"));
		
		this.props.apiCall("POST", "/competition/register/current", ({id}) => {
			this.party = {...data, id};
			this.context.toggleModal(true, <ContestRegisterModal partyId={id}/>);
			this.props.invalidateUserInfo();
			this.props.invalidateEntries();
		}, data, () => alert("Du kan kun registrere din fest en gang."))
	};

	savePartyName = (name) => {
		this.props.setPartyInfo({data: name});
		this.context.toggleModal(false);
	}

	savePartyDate = (date) => {
		this.props.setPartyInfo({data: date});
		this.context.toggleModal(false);
	}

	render(){
		const {cart, sections, partyInfo} = this.props;

		const {total} = extractCartData(cart, this.props.products);
		return (
			<div id="myPartyWrapper" className={!isEmpty(cart) ? "withProd" : ""}>
				<div className="myPartyContainer">	
					<div className="partyInfo">
						<Link className="toCheckout" to={"/checkout"}>
							<img src={cartDarkGreenIcon} alt="Checkout"/>
							<span>{formatPrice(total)}</span>
						</Link>
						<div className="setPartyName" onClick={() => this.context.toggleModal(true, <AddPartyName onSubmit={this.savePartyName}/>)}>
							{ partyInfo.name ?
								<h2 className="partyName">{partyInfo.name}</h2> :
								<Fragment>
									<span>Din fest</span>
									<img src={penGreenIcon} alt="Pen"/>
								</Fragment>
							}
						</div>
						<div className="setPartyDate" onClick={() => this.context.toggleModal(true, <AddPartyDate onSubmit={this.savePartyDate}/>)}>
							{ partyInfo.time ? 
								<span>{formatTime(partyInfo.time, true)}</span> :
								<Fragment>
									<span>DATO</span>
									<img src={penGreyIcon} alt="Pen"/>
								</Fragment>
							}
						</div>
					</div>
					{
						isEmpty(cart) ? 
						<div className="getStartedWrapper">
							<img src={polaroidImg} alt="Polaroid"/>
							<p>Create your dream party by adding all kinds products to your list</p>		
							<Button>Get Started <img src={confettiIcon} alt="Confetti"/></Button>					
						</div> :
						<div className="sectionsList">
							{mapObjectToArray(sections, (x,i) => <Section key={i} tile={x}/>)}
						</div>
					}
				</div>
			</div>
		)
	}
}
export const SectionList = reduxWrapper("loadProducts", "loadCart", "loadSections", "getUserId", "getPartyInfo", "setPartyInfo", "getApiCall", "invalidateUserInfo", "loadUserInfo", "invalidateEntries")(SectionListRender);

const SectionRender = ({products, cart, tile, awaitCart}) => {
	
	useEffect(() => {
		awaitCart(() => {
			extractProducts();
		})
	});

	const extractProducts = () => {
		let prods = [];
		tile.children.forEach(section => {
			let extractedCart = (extractCartData(cart, products, null, section.id));
			prods.push(extractedCart.products);
		});
		return prods.flat();
	};

  return(
		extractProducts().length > 0 &&
		<div className="section">
			<h1>{tile.title}</h1>
			<div className="sectionProductList">
				{extractProducts().map((x,i) => <SectionProduct key={i} vanity={tile.vanity} {...x}/>)}
			</div>
		</div>
	)
};
SectionRender.propTypes = {
  tile: PropTypes.object,
	products: PropTypes.object,
	sections: PropTypes.object
}
export const Section = reduxWrapper("loadCart", "loadProducts", "getCacheProduct", "loadPartyInfo", "loadSections")(SectionRender);

const SectionProductRender = ({product, deleteCart, vanity, qty, cacheProduct, productId}) => {

	useEffect(() => {
		cacheProduct({product: productId, full: true});
	}, []);

	return (
		<div className="sectionProduct">
			<Link to={relativePath(`/${vanity}/${productId}`)}>
				<div className="prodInfo">
					<span className="name">{ product.name } { qty > 1 ? `(${qty})` : "" }</span>
					<span className="trailingLine"/>
					{ product.price && product.price * qty }
				</div>
				<div className="description" dangerouslySetInnerHTML={{__html: product.shortDescription}}/>
			</Link>
		</div>
	)
};
const SectionProduct = reduxWrapper("getCacheProduct", "deleteCart")(SectionProductRender);

const ActionBar = ({onClick, isNav}) => {
	const context = useContext(ModalContext);
	const promptCheckout = {
		text: "Køb eller reserver din fest! Når man reservere en fest betales der en uge før festen afholdelse.",
		confirm: () => {
			this.context.toggleModal(false);
			this.props.history.push("/reservere");
		},
		decline: () => {
			this.context.toggleModal(false);
			this.props.history.push("/checkout");
		},
		confirmText: "Reserver til senere",
		declineText: "Køb nu"
	};

	return (
		<div className="actionBar">
			<div onClick={() => onClick(false)} className={["actionBarBtn", isNav ? "" : "chosen"].join(" ")}>
				<img src={isNav ? listLightGreyIcon : listGreenIcon} alt="Din fest"/>
				Din fest
			</div>
			<div className={["actionBarBtn", isNav ? "chosen" : ""].join(" ")} onClick={() => onClick(true)}>
				<img src={isNav ? plusGreenIcon : plusLightGreyIcon} alt="Tilføj vare"/>
				Tilføj vare
			</div>
			<div 
				className="actionBarBtn" 
				onClick={ () => context.toggleModal(true,
					<PromptModal {...promptCheckout} />
				)} 
			>
				<img src={cartLightGreyIcon} alt="Bestil"/>
				Bestil
			</div>
		</div>
	)
};

const SectionNavigationRender = ({sections, apiCall}) => {
 const [bundles, setBundles] = useState([]);

 let mounted = true;

	useEffect(() => {
		apiCall("GET", "products/bundles", x => mounted && setBundles(x));
		return ()=> {
			mounted = false;
		}
	}, [])

	return (
		<div id="sectionNavWrapper">
			<div className="sectionNav">
				<div className="navTitle">
					<span>Tilføj produkter</span>
				</div>
				<nav>
					<ul>
						{mapObjectToArray(sections, (section, i) => 
							<SectionNavElement section={section} key={i}/>
						)}
					</ul>
				</nav>
				<div className="bundleNav">
					<span>Grydeklare fester</span>
					<Link to={"/pakker"}>Se alle</Link>
					<div className="bundlesSlider">
						{bundles.map((x, i) => 
							<Link to={`/pakker/${x.identifier}`} key={i} className="bundle">
								<img src={getImage(x.image)} alt={x.identifier}/>
								<span>{x.title}</span>
							</Link>
						)}
					</div>
				</div>
			</div>
		</div>
	)
};
const SectionNavigation = reduxWrapper("loadSections", "getApiCall")(SectionNavigationRender);

const SectionNavElement = ({section}) => {

	const [expand, setExpand] = useState(false);

	return (
		<li onClick={() => setExpand(!expand)}>
			<div className="sectionTitle">
				<span>{section.title}</span>
				<img src={dropArrowIcon} alt="Drop down" style={{transform: expand ? "rotate(270deg)" : "rotate(90deg)"}}/>
			</div>
			<Collapse in={expand}>
				<ul>
					{ section.children.map(x => 
							<li key={x.id}>
								<Link to={`/minfest/${x.vanity}`} className="sectionLink">
									<div className="title">{x.title}</div>
									<div className="image"><img src={getImage(x.image)} alt={x.title}/></div>
								</Link>
							</li>
						)	
					}
				</ul>
			</Collapse>
		</li>
	)
};

export default MyParty;


// WEBPACK FOOTER //
// ./src/components/views/myparty.js